<script setup lang="ts">
import { computed } from 'vue'

import LocationHero from './LocationHero.vue'

type LocationHeaderProps = {
  tabs: Array<{
    domain: string
    external: boolean
    currentPage: boolean
    title: string
    openInNewTab: boolean
    url: string
  }> | null
  title: string
  subTitle: {
    tag: string
    address: string
  }
  usps: string[]
  images: Array<{
    src: string
    altText: string
    width?: number | null
    height?: number | null
    focalPointX?: number | null
    focalPointY?: number | null
  }>
  mediaOverview: {
    title: string
    openInNewTab: boolean
    url: string
  }
  quote?: string
}

const props = defineProps<LocationHeaderProps>()

// Transform the API data to match LocationHero props
const transformedProps = computed(() => ({
  tabs: props.tabs?.map(tab => ({
    title: tab.title,
    url: tab.url,
    domain: tab.domain,
    external: tab.external,
    openInNewTab: tab.openInNewTab
  })) ?? [],
  title: props.title,
  subTitle: props.subTitle,
  usps: props.usps,
  media: props.images.map(img => ({
    src: img.src,
    altText: img.altText,
    width: img.width,
    height: img.height,
    focalPointX: img.focalPointX,
    focalPointY: img.focalPointY
  })),
  mediaOverviewUrl: {
    title: props.mediaOverview.title,
    url: props.mediaOverview.url,
    openInNewTab: props.mediaOverview.openInNewTab
  },
  quote: props.quote
}))
</script>

<template>
  <div>
    <LocationHero v-bind="transformedProps" />
  </div>
</template>
